<template>
  <svg height="30"
       fill="none"
       viewBox="0 0 30 30"
       width="30"
       xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.03691 14.9231C2.77288 12.7191 2.16255 10.9193 1.79453 9.09494C1.25024 6.39676 2.49583 3.76107 4.55926 2.07929C5.43134 1.3685 6.43106 1.61135 6.94675 2.53652L8.11099 4.6252C9.0338 6.28074 9.49521 7.10851 9.40369 7.98611C9.31217 8.86371 8.68991 9.57847 7.44538 11.008L4.03691 14.9231ZM4.03691 14.9231C6.59542 19.3844 10.6105 23.4017 15.0769 25.9632M15.0769 25.9632C17.281 27.2272 19.0808 27.8375 20.9051 28.2055C23.6033 28.7498 26.239 27.5042 27.9208 25.4408C28.6316 24.5687 28.3887 23.569 27.4636 23.0533L25.3749 21.8891C23.7193 20.9663 22.8916 20.5049 22.014 20.5964C21.1364 20.6879 20.4216 21.3102 18.9921 22.5547L15.0769 25.9632Z"
      stroke="#FF9500"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path
      d="M25.6667 3V12.3333M17.6667 3V12.3333"
      stroke="#FF9500"
      stroke-linecap="round"
      stroke-width="1.5"
    />
  </svg>
</template>
